import Ajax from '@/utils/Ajax';
let jsApiCache;

// 请求接口进行wx.config
export default function wechatConfig() {
  return new Promise((resolve, reject) => {
    // 已经请求过接口直接配置
    if (jsApiCache) {
      setWechatConfig(jsApiCache, resolve, reject);
      return;
    } else {
      requestConfig(resolve, reject).then((res) => {
        jsApiCache = res;
        // 如果微信还未注册WeixinJSBridge
        if (typeof window.WeixinJSBridge == 'undefined') {
          $(document).on('WeixinJSBridgeReady', function() {
            setWechatConfig(jsApiCache, resolve, reject);
          });
        } else {
          setWechatConfig(jsApiCache, resolve, reject);
        }
      });
    }
  });
}

function setWechatConfig(jsApi, resolve, reject) {
  let config = {
    debug: jsApi.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: jsApi.appId, // 必填，公众号的唯一标识
    timestamp: jsApi.timestamp, // 必填，生成签名的时间戳
    nonceStr: jsApi.nonceStr, // 必填，生成签名的随机串
    signature: jsApi.signature, // 必填，签名，见附录1
    jsApiList: jsApi.jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
  };
  wx.config(config);
  console.log('setWechatConfig');
  wx.ready(() => {
    console.log('wx.ready');
    resolve(jsApi);
  });
  wx.error((err) => {
    console.error('wx.error', err);
    reject(err);
  });
}

/**
请求微信wx.config配置项信息         
返回数据  {
        debug,
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList
    }
 *
 * @param {*} resolve
 * @param {*} reject
 * @returns
 */
function requestConfig(resolve, reject) {
  return Ajax.post('/site/jssdk?lang=zh', {
    url: window.location.href.split('#')[0]
  })
    .then((res) => {
      if (res.code == 0) {
        return res.data;
      } else {
        reject();
      }
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    });
}
